import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { noteTypeApi } from '../../utilities/api';
import { NoteType } from '../../utilities/interfaces/NoteType';

interface noteTypeState {
  noteTypes: NoteType[];
  draftNoteTypes: NoteType[];
}

const initialState: noteTypeState = {
  noteTypes: [],
  draftNoteTypes: [],
};

const noteTypeSlice = createSlice({
  name: 'noteType',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getNoteTypes.fulfilled, (state, action: any) => {
      state.noteTypes = action.payload;
    });
    builder.addCase(getDraftNoteTypes.fulfilled, (state, action: any) => {
      state.draftNoteTypes = action.payload;
    });
  },
});

export const getNoteTypes = createAsyncThunk('stateNoteType/getNoteTypes', async () => {
  const response = await noteTypeApi.get();
  return response;
});

export const getDraftNoteTypes = createAsyncThunk(
  'stateNoteType/getNoteTypesForDraft',
  async () => {
    const response = await noteTypeApi.getNoteTypesForDraft();
    return response;
  }
);

export default noteTypeSlice.reducer;
